import { isEmpty } from 'ramda';
import * as React from 'react';

import { useLoader } from './utils/useLoader';

import { IOffersFeedProps } from '../types';
import { useOffersHistoryContext } from '../../context';
import { EmptyData, Loading, OffersFeed, Error } from '../../components/Desktop';
import { ETypeFilterValues, mapLocationVal } from '../../types';

export interface IFeedContainerProps extends Omit<IOffersFeedProps, 'data' | 'viewedOffers' | 'feedViewState'> {
  isSpoiler?: boolean;
}

export const FeedContainer: React.FC<IFeedContainerProps> = ({ isSpoiler, ...rest }) => {
  const {
    data: { listingSpoiler, listing },
    viewedOffers,
    roomsFilterActiveValue,
    statusFilterActiveValue,
    typeFilterActiveValue,
  } = useOffersHistoryContext();

  const { data, isError, isFetching, isLoadMore } = isSpoiler ? listingSpoiler : listing;
  const filtersStr = React.useMemo(() => {
    const roomsFilterValue = roomsFilterActiveValue || 'all';
    const statusFilterValue = statusFilterActiveValue || 'all';
    const typeFilterValue = typeFilterActiveValue as ETypeFilterValues;

    return typeFilterValue
      ? `${mapLocationVal[typeFilterValue]}/${statusFilterValue}/${roomsFilterValue}`
      : `${statusFilterValue}`;
  }, [roomsFilterActiveValue, statusFilterActiveValue, typeFilterActiveValue]);
  const containerRef = React.useRef<HTMLDivElement>(null);
  const feedViewState = React.useState(false);
  const loaderHeight = useLoader(containerRef, feedViewState[0]);

  if (isError) {
    return <Error />;
  }

  if (isFetching && !isLoadMore) {
    return <Loading height={loaderHeight} />;
  }

  if (!data) {
    return null;
  }

  const { offers } = data;

  if (isEmpty(offers) && !isFetching) {
    return <EmptyData />;
  }

  return (
    <div ref={containerRef} style={{ height: '100%' }}>
      <OffersFeed {...rest} data={offers} viewedOffers={viewedOffers} feedViewState={feedViewState} key={filtersStr} />
    </div>
  );
};
